import { DateTime } from 'luxon';

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.getElementsByClassName('time-select')).forEach((el) => {
    const selectEl     = el.querySelectorAll('select')[0];
    const valueFieldEl = el.querySelectorAll('input[type="hidden"]')[0];

    if (valueFieldEl.value) {
      const selectedTime = DateTime.fromISO(valueFieldEl.value);
      const timeValue = `${selectedTime.toFormat('HH')}:${selectedTime.toFormat('mm')}`;
      selectEl.options.selectedIndex = Array.from(selectEl.options).findIndex(option => option.value == timeValue);
    }

    selectEl.addEventListener('change', () => {
      const [hours, minutes] = selectEl.value.split(':');
      valueFieldEl.value = DateTime.fromObject({
        year: 2025,
        month: 1,
        day: 2, 
        hour: parseInt(hours),
        minute: parseInt(minutes)
      }).toUTC().toString()
    });
  });

  Array.from(document.getElementsByClassName('date-time-select')).forEach((el) => {
    const inputEl      = el.querySelectorAll('input[type="datetime-local"')[0];
    const valueFieldEl = el.querySelectorAll('input[type="hidden"]')[0];

    if (valueFieldEl.value) {
      const selectedTime = DateTime.fromISO(valueFieldEl.value);
      //remove timezone since it invalidates the format expected by the element
      inputEl.value = selectedTime.toISO().slice(0, 16);
    }

    inputEl.addEventListener('change', () => {
      valueFieldEl.value = DateTime.fromISO(inputEl.value).toUTC().toISO();
    });
  });
});
